import { contactForm } from "./contactForm.js";
import { plans } from "./plansData.js";

export const infoCard = {
    elem: null,
    listElem: null,
    itemElem: "<li class='info-card__featue-item'></li>",

    setElements() {
        this.elem = document.querySelector('#plans-prices .main-content__info-card');
        this.listElem = document.querySelector('#plans-prices .info-card__features-list');
        this.table.elem = document.querySelector('.fees-table');
        this.table.mainContainer = document.querySelector('.main-content__tabs');
    },

    updatePlanTitle(newText) {
        if (!this.elem) this.setElements();
        if (!this.elem) return;

        this.elem.querySelector('.info-card__plan-title').textContent = newText;
    },
    
    updatePlanPrice(newPrice) {
        if (!this.elem) this.setElements();
        if (!this.elem) return;

        this.elem.querySelector('.info-card__price').textContent = newPrice
    },

    updatePlanPrompt(plan) {
        if (!this.elem) this.setElements();
        if (!this.elem) return;

        this.elem.querySelector('.info-card__promo-string').textContent = plans[plan].promoString;
    },

    updateFeaturesList(plan) {
        if (!this.listElem) this.setElements();
        if (!this.listElem) return;

        this.listElem.innerHTML = '';
        const liArr = plans[plan].features.map(featureText => {
            const newItemElem = document.createElement('li');
            newItemElem.classList.add('info-card__featue-item');
            newItemElem.textContent = featureText;
            return newItemElem;
        });
        this.listElem.append(...liArr);
    },

    table: {
        elem: null,
        mainContainer: null,

        create() {
            if (!this.elem || !this.mainContainer) return;

            this.elem.append(document.createElement('tbody'));
            this.updateTableData();
            this.mainContainer.addEventListener('tab-change', this.updateTableData.bind(this));
        },
        updateTableData() {
            if (!this.elem || !this.mainContainer || !this.elem.children[0]) return;

            const createTD = (data) => {
                const el = document.createElement('td');
                el.textContent = data;
                if (el.textContent.includes('Included in monthly fee')) el.colSpan = 2;
                if (el.textContent.includes('%')) el.classList.add('bold');
                return el
            };
        
            const createTR = (tdArr) => {
                const el = document.createElement('tr');
                const copy = tdArr.filter(el => !!el);
                el.append(...copy);
                return el;
            };
            
            const selectedPlan = this.mainContainer.dataset.selectedTab;
            this.elem.children[0].innerHTML = '';
            if (selectedPlan == 'enterprise') return this.elem.children[0].innerHTML = "<p>Special pricing rules shaped to your business</p>"
            
            for (const range in plans[selectedPlan].fees) {
                const tdArr = [
                    plans[selectedPlan].fees[range] == '0' ? null : createTD((plans[selectedPlan].fees[range] * 100).toFixed(1) + '%'),
                    createTD(plans[selectedPlan].fees[range] == '0' ? 'Included in monthly fee' : 'per fulfilled order'),
                    createTD(range.includes('Infinity') ? 'From 10001' : range)
                ];
    
                this.elem.children[0].append(createTR(tdArr));
            }
        }
    },

    init() {
        this.setElements();
        if (!this.elem || !this.listElem) return;

        this.table.create();
        this.updatePlanPrompt('free');
        this.updateFeaturesList('free');
    }

}
